import { useNavigate } from "react-router-dom";
import UserServices from '../services/UserServices';

const Logout = () => {
    const url = process.env.REACT_APP_SITE_URL;
    const token = sessionStorage.getItem('token');
    let navigate = useNavigate();

    UserServices.Logout(token).then(data => {
        console.log(data);
        if (data['success'] === true) {

            sessionStorage.removeItem('token');
            sessionStorage.removeItem('id_user');
            sessionStorage.removeItem('first_name');
            sessionStorage.removeItem('last_name');

            window.location.href = '/rapport/frontend/';
        } else if (data['success'] === false) {
            console.log(data);
        }
    });

}

export default Logout;